// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Sb-x","title":"Images90_title__3QhE0","images":"Images90_images__1OSYw"};